import React, { useContext } from 'react'
import CurrentUserContext from "../../Contexts/userContexts";
import "./Counter.css";

const CounterComponent = () => {
    const { goalkeeper, defender, midfielder, forward } = useContext(CurrentUserContext)

    return (
        <div className='counter'>
            <div className='counterPosition'>
                <div className='grid-items'>Position</div>
                <div className='grid-item'>Goalkeeper</div>
                <div className='grid-item'>Defenders</div>
                <div className='grid-item'>Midfielders</div>
                <div className='grid-item'>Forwards</div>
            </div>
            <div className='counterYouHave'>
                <div className='grid-items'>Players</div>
                <div className='grid-item'>{`${goalkeeper.length}`}/1</div>
                <div className='grid-item'>{`${defender.length}`}/4</div>
                <div className='grid-item'>{`${midfielder.length}`}/4</div>
                <div className='grid-item'>{`${forward.length}`}/2</div>
            </div>
        </div>
    )
}

export default CounterComponent;